// extracted by mini-css-extract-plugin
export default {"wrapper_0":"UKZJtLbQ","wrapper_1":"ripoMjRW","img_0":"j388NmEq","img_1":"VhFR4KWK"};